module.exports = __webpack_public_path__ + "static/media/corner-up-right.9051bc52.svg";